import './AppFooter.styles.scss';

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button } from '@material-ui/core';
import MyThemeContext from '../../contexts/theme-context/ThemeProviderContext';
import { useContext } from 'react';

const AppFooter = () => {
	const { themeType } = useContext(MyThemeContext);
	return (
		<div className={`appFooter ${themeType}`}>
			<div className="mfaContainer">
				<div className="footerContent">
					<div className="footerLinks">
						<Button component={RouterLink} to="/home">
							Home
						</Button>
						<span></span>
						<Button component={RouterLink} to="/about">
							AboutUs
						</Button>
						<span></span>
						<Button component={RouterLink} to="/terms">
							Terms
						</Button>
					</div>

					<div className="copyRightDiv">
						<p>
							Copyright <span className="copySpan">&copy;</span> 2020 Socialize.
							All rights reserved.
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};

export default AppFooter;
